<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator'
const STORE_MODULE_NAME = 'TherapyRoomsHipaaModule'

export default {
  name: 'WrapperTherapyRoomsHipaaModule',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
}
</script>
